import { render, staticRenderFns } from "./InputFields.vue?vue&type=template&id=09622444&scoped=true&"
import script from "./InputFields.vue?vue&type=script&lang=js&"
export * from "./InputFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09622444",
  null
  
)

export default component.exports